import { FaRegCopyright } from "react-icons/fa";

const Footer = () => (
  <section className="w-[100vw] h-[40px] flex justify-center items-center relative bg-black">

    <div className="lg:grid justify-center lg:w-[33%]">
      <div className="flex items-center text-white mt-5 lg:mt-0 lg:mb-0 mb-5">
        <FaRegCopyright />
        <p className=" ml-4"> 2023 Sploitec. All Rights Reserved</p>
      </div>
    </div>


  </section>
);

export default Footer;
